import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, SearchIcon, PenToolIcon, BarChart2Icon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLid2Page: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2096">
      <SEO data-id="element-2097" />
      <Header data-id="element-2098" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2099">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2100">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2101">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2102" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2103">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2104">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2105">
                <img src="https://cdn.magicpatterns.com/uploads/3h5jPU9M1S7oTcbxfUFYhr/image.png" alt="Beer" className="w-full h-full object-cover" style={{
                objectPosition: 'center 35%'
              }} data-id="element-2106" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2107">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2108">
                Beer
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2109">
                SEO Specialist
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2110">
                <p className="mb-4" data-id="element-2111">
                  Als SEO Specialist bij Noord Digital ben ik verantwoordelijk
                  voor de organische vindbaarheid van onze klanten. Mijn doel is
                  niet alleen om websites hoger in Google te krijgen, maar
                  vooral om de juiste, koopgerichte bezoekers aan te trekken.
                </p>
                <p className="mb-4" data-id="element-2112">
                  Ik duik diep in de data om te begrijpen waar de doelgroep naar
                  zoekt en welke intentie daarachter zit. Op basis daarvan bouw
                  ik ijzersterke SEO-structuren en contentstrategieën die op de
                  lange termijn structureel leads opleveren.
                </p>
                <p data-id="element-2113">
                  Mijn werkwijze kenmerkt zich door een technische basis
                  gecombineerd met sterke, relevante content. Ik geloof dat SEO
                  geen trucje is, maar het bouwen van de beste antwoorden op de
                  vragen van je potentiële klanten.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2114">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2115">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2116">
                  <SearchIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2117" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2118">SEO Strategie</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2119">
                  <PenToolIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2120" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2121">
                    Content Marketing
                  </h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2122">
                  <BarChart2Icon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2123" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2124">Keyword Research</h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2125">
                Neem contact op met Beer
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2126" />
    </div>;
};